export default __webpack_public_path__ + "static/media/openstreetmaps.3592da08.PNG";